// extracted by mini-css-extract-plugin
export default {"controls":"BottomControls_controls__Sr6A1"};